// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-grid,
.item-grid {
  grid-template-columns: 1fr 25% 25%;
}

/* Stops the icon from resizing when checked */
.market-checkbox .icon {
  width: 20px !important;
  height: 20px !important;
}

.markets-table {
  width: 100vw;
  height: calc(100vh - 60px) !important;
}
.markets-table-beta {
  height: calc(100vh - 78px) !important;
}

.text-2lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}`, "",{"version":3,"sources":["webpack://./src/context/markets.css"],"names":[],"mappings":"AAAA;;EAEE,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".heading-grid,\n.item-grid {\n  grid-template-columns: 1fr 25% 25%;\n}\n\n/* Stops the icon from resizing when checked */\n.market-checkbox .icon {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.markets-table {\n  width: 100vw;\n  height: calc(100vh - 60px) !important;\n}\n.markets-table-beta {\n  height: calc(100vh - 78px) !important;\n}\n\n.text-2lines {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
